export default {

  namespaced: true,

  state: () => ({

    hasCustomer: true,
    hasSession: true,
    hasSelfRegistration: true,
    hasTranscription: true,

  }),

  mutations: {
    setOnboardingData(state, company) {
      state.hasCustomer = company.has_customer !== undefined
        ? !!company.has_customer
        : company.customers_count > 0

      state.hasSession = company.has_session !== undefined
        ? !!company.has_session
        : company.sessions_count > 0

      state.hasSelfRegistration = company.has_self_registration !== undefined
        ? !!company.has_self_registration
        : true

      state.hasTranscription = company.has_transcription !== undefined
        ? !!company.has_transcription
        : true
    },

    customerStored(state) {
      state.hasCustomer = true
    },

    sessionStored(state) {
      state.hasSession = true
    },

    transcriptionStored(state) {
      state.hasTranscription = true
    },
  },

}